import { render, staticRenderFns } from "./InHouseWaitingTable.vue?vue&type=template&id=0d5b1dbb"
import script from "./InHouseWaitingTable.vue?vue&type=script&lang=js"
export * from "./InHouseWaitingTable.vue?vue&type=script&lang=js"
import style0 from "./InHouseWaitingTable.vue?vue&type=style&index=0&id=0d5b1dbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports